export default __webpack_public_path__ + "static/media/keyvis_players_mob@2x.bf3d8140.png";